export const getFormattedAPIEndPoint = (url, obj = {}) => {
  let formattedURL = url
  for (let placeholder in obj) {
    formattedURL = formattedURL.replace(
      placeholder,
      encodeURIComponent(obj[placeholder])
    )
  }
  return formattedURL
}
